import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import { PARTNERSHIP_URL } from '../constants/index';

export const useUpdatePassword = () => {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [updateStatus, setUpdateStatus] = useState('Update');

  const [oldPasswordError, setOldPasswordError] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [passwordsError, setPasswordsError] = useState('');
  const [passwordChangeSuccessful, setPasswordChangeSuccessful] = useState(false);

  const cookies = new Cookies();

  const isOldPasswordValid = () => {
    if (!oldPassword) {
      setOldPasswordError('Please enter old password');
      return false;
    }
    setOldPasswordError('');
    return true;
  };

  const isNewPasswordValid = () => {
    if (!newPassword) {
      setNewPasswordError('Please enter new password');
      return false;
    }
    if (newPassword.length < 8) {
      setNewPasswordError('Password must be at least 8 characters long');
      return false;
    }
    if (
      !/[a-z]/.test(newPassword) ||
      !/[A-Z]/.test(newPassword) ||
      !/\d/.test(newPassword) ||
      !/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)
    ) {
      setNewPasswordError(
        'Password must contain uppercase, lowercase, numbers and special characters'
      );
      return false;
    }
    setNewPasswordError('');
    return true;
  };

  const isConfirmPasswordValid = () => {
    if (isNewPasswordValid && !confirmPassword) {
      setConfirmPasswordError('Please enter confirm password');
      return false;
    }
    if (newPassword !== confirmPassword) {
      setConfirmPasswordError('Password not matching');
      setPasswordChangeSuccessful(false);
      return false;
    }
    setConfirmPasswordError('');
    return true;
  };

  const isPasswordsValid = () => {
    if (isNewPasswordValid && !confirmPassword) {
      setConfirmPasswordError('Please enter confirm password');
      return false;
    }
    if (newPassword !== confirmPassword) {
      setConfirmPasswordError('Password not matching');
      setPasswordChangeSuccessful(false);
      return false;
    }
    if (isNewPasswordValid && newPassword === confirmPassword) {
      if (oldPassword === newPassword) {
        setPasswordsError('New password cannot be same as old password');
        return false;
      }
    }
    setPasswordsError('');
    return true;
  };

  const handleUpdate = async () => {
    const isValidOldPassword = isOldPasswordValid();
    const isValidNewPassword = isNewPasswordValid();
    const isValidConfirmPassword = isConfirmPasswordValid();
    const isValidPasswords = isPasswordsValid();

    const encodedOldPassword = btoa(oldPassword);
    const encodedNewPassword = btoa(newPassword);

    if (isValidOldPassword && isValidNewPassword && isValidConfirmPassword && isValidPasswords) {
      try {
        const token = cookies.get('token');
        setUpdateStatus('Updating...');
        const response = await axios(`${PARTNERSHIP_URL}/users/updatePassword`, {
          method: 'PATCH',
          headers: {
            newPassword: encodedNewPassword,
            oldPassword: encodedOldPassword,
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({})
        });
        setUpdateStatus('Update');
        if (response.status === 200) {
          setOldPasswordError();
          setConfirmPasswordError();
          setPasswordChangeSuccessful(true);
          setTimeout(() => {
            window.history.pushState({}, '', '/');
            navigate('/home');
          }, 500);
        }
      } catch (error) {
        setPasswordsError('Incorrect Old Password');
        setUpdateStatus('Update');
      }
    }
  };

  return {
    oldPassword,
    newPassword,
    confirmPassword,
    setOldPassword,
    setNewPassword,
    setConfirmPassword,
    showOldPassword,
    setShowOldPassword,
    showNewPassword,
    setShowNewPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    oldPasswordError,
    setOldPasswordError,
    newPasswordError,
    setNewPasswordError,
    confirmPasswordError,
    setConfirmPasswordError,
    handleUpdate,
    passwordChangeSuccessful,
    updateStatus,
    passwordsError
  };
};
